/* eslint-disable */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Import dependencies
import { initialiser, hasDifferentValues, getLastElement, isHidden } from '../utilitybelt';

var defaultSettings = {
  fieldList: 'input, select, textarea',
  errorClass: 'has-error',
  errorMessageClass: 'c-form-error',
  successClass: 'has-success',
  successMessageClass: 'c-form-success',
  successMessage: 'Great!',
  defaultMessage: 'Please enter a valid value',
  valueMissingMessage: 'Please complete this field',
  valueMissingCheckboxMessage: 'Please ensure this is ticked',
  valueMissingCheckboxGroupMessage: 'Please select at least one',
  typeMismatchMessageEmail: 'Please enter a valid email address',
  typeMismatchMessageUrl: 'Please enter a valid url',
  incorrectLengthMessage: 'Please enter the correct length',
  emailMismatchMessage: 'Please make sure your emails match',
  passwordMismatchMessage: 'Please make sure your passwords match',
  confirmMismatchMessage: 'Confirm value does not match',
  noSuccessMessage: false
};

var Validator = function Validator(config) {
  var _this = this;

  _classCallCheck(this, Validator);

  this.init = function () {
    _this.form.setAttribute('novalidate', true);
    _this.bindEvents();
  };

  this.bindEvents = function () {
    // Check all fields on submit
    _this.form.addEventListener('submit', _this.handleSumit, false);

    // Listen to all blur events
    _this.form.addEventListener('blur', _this.handleBlur, true);

    // Loop through all fields and add input events
    for (var i = 0; i < _this.fields.length; i += 1) {
      _this.fields[i].addEventListener('input', _this.handleChange);
    }
  };

  this.handleBlur = function (e) {
    if (e.target.hasAttribute('data-no-validation')) return;

    // Validate the field
    var error = _this.hasError(e.target);

    // If there's an error, show it
    if (error) {
      _this.removeMessage(e.target, _this.settings.successClass, _this.settings.successMessageClass);
      _this.showError(e.target, error);
      return;
    }

    // Otherwise, remove any existing error message and show success message
    _this.removeMessage(e.target, _this.settings.errorClass, _this.settings.errorMessageClass);

    if (_this.settings.noSuccessMessage || e.target.hasAttribute('data-no-success')) return;
    _this.showSuccess(e.target);
  };

  this.handleSumit = function (e) {
    _this.state.hasErrors = false;

    for (var i = 0; i < _this.fields.length; i += 1) {
      var field = _this.fields[i];

      if (field.hasAttribute('data-no-validation')) return;

      var error = _this.hasError(field);

      if (error) {
        _this.removeMessage(field, _this.settings.successClass, _this.settings.successMessageClass);
        _this.showError(field, error);
        _this.state.hasErrors = true;
      }
    }

    // If there are errrors, don't submit form and focus on first element with error
    if (_this.state.hasErrors) {
      e.preventDefault();
    }
  };

  this.handleChange = function (e) {
    if (e.target.hasAttribute('data-no-validation')) return;
    // Validate the field
    var error = _this.hasError(e.target);

    // If there's an error remove success message
    if (error) {
      _this.removeMessage(e.target, _this.settings.successClass, _this.settings.successMessageClass);
      return;
    }

    // Otherwise, remove error message and show success
    _this.removeMessage(e.target, _this.settings.errorClass, _this.settings.errorMessageClass);

    if (_this.settings.noSuccessMessage || e.target.hasAttribute('data-no-success')) return;
    _this.showSuccess(e.target);
  };

  this.removeMessage = function (fieldElement, fieldClass, messageClass) {
    // If the field is a radio button and part of a group,
    // error all and get the last item in the group
    var field = fieldElement;

    if ((field.type === 'radio' || field.type === 'checkbox') && field.name) {
      field = getLastElement(field.name);
    }

    // Define the field container
    var fieldContainer = field.parentNode;

    // Remove error class to field
    fieldContainer.classList.remove(fieldClass);

    // Get field id or name
    var id = field.id || field.name;
    if (!id) return;

    // Check if an error message is in the DOM
    var escapedId = id.replace(/\[/g, '\\[').replace(/]/g, '\\]');
    var message = field.form.querySelector('.' + messageClass + '#for-' + escapedId);
    if (!message) return;

    // If so, hide it
    message.innerHTML = '';
  };

  this.showError = function (fieldElement, error) {
    // If the field is a radio button and part of a group,
    // error all and get the last item in the group

    var field = fieldElement;

    if ((field.type === 'radio' || field.type === 'checkbox') && field.name) {
      field = getLastElement(field.name);
    }

    // Define the field container
    var fieldContainer = field.parentNode;
    var fieldOuterContainer = field.parentNode.parentNode;

    // Add error class to field
    fieldContainer.classList.add(_this.settings.errorClass);

    // Get field id or name
    var id = field.id || field.name;
    if (!id) return;

    // Check if error message field already exists. If not, create one
    var escapedId = id.replace(/\[/g, '\\[').replace(/]/g, '\\]');
    var message = fieldOuterContainer.querySelector('.' + _this.settings.errorMessageClass + '#for-' + escapedId);

    if (!message) {
      message = document.createElement('div');
      message.className = _this.settings.errorMessageClass;
      message.id = 'for-' + id;

      fieldOuterContainer.appendChild(message, field.nextSibling);
    }

    // Update error message
    message.innerHTML = error;
  };

  this.showSuccess = function (fieldElement) {
    // If the field is a radio button and part of a group,
    // error all and get the last item in the group

    var field = fieldElement;

    if ((field.type === 'radio' || field.type === 'checkbox') && field.name) {
      field = getLastElement(field.name);
    }

    // Define the field container
    var fieldContainer = field.parentNode;
    var fieldOuterContainer = field.parentNode.parentNode;

    // Add error class to field
    fieldContainer.classList.add(_this.settings.successClass);

    // Get field id or name
    var id = field.id || field.name;
    if (!id) return;

    // Check if error message field already exists. If not, create one
    var escapedId = id.replace(/\[/g, '\\[').replace(/]/g, '\\]');
    var message = fieldOuterContainer.querySelector('.' + _this.settings.successMessageClass + '#for-' + escapedId);

    if (!message) {
      message = document.createElement('div');
      message.className = _this.settings.successMessageClass;
      message.id = 'for-' + id;

      fieldOuterContainer.appendChild(message, field.nextSibling);
    }

    // Update error message
    message.innerHTML = _this.settings.successMessage;
  };

  this.hasError = function (field) {
    // Don't disabled fields
    if (field.disabled || isHidden(field)) return '';

    // Check if field is a confirm field (compares it against a different fields ID)
    var compare = field.getAttribute('data-confirm') || false;
    var originalField = compare ? document.getElementById(compare) : null;

    // Check if field is a checkbox
    var isCheckbox = field.getAttribute('type') === 'checkbox';
    var checkBoxGroup = field.getAttribute('data-group');

    // If compare parameter exists
    if (originalField && hasDifferentValues(field, originalField)) {
      if (field.name === 'confirm-email-address') return _this.settings.emailMismatchMessage;
      if (field.name === 'confirm-password') return _this.settings.passwordMismatchMessage;
      return _this.settings.confirmMismatchMessage;
    }

    // Get validity
    var validity = field.validity;

    if (isCheckbox && checkBoxGroup) {
      var checkboxes = document.querySelectorAll('[data-group=' + checkBoxGroup + ']');
      var isGroupValid = [].concat(_toConsumableArray(checkboxes)).some(function (checky) {
        return checky.checked === true;
      });
      return isGroupValid ? '' : _this.settings.valueMissingCheckboxGroupMessage;
    }

    // If valid, return null
    if (validity.valid) return '';

    // If field is required and empty and IS a checkbox
    if (validity.valueMissing && isCheckbox) return _this.settings.valueMissingCheckboxMessage;

    // If field is required and empty and NOT a checkbox
    if (validity.valueMissing) return _this.settings.valueMissingMessage;

    // If not the right type
    if (validity.typeMismatch) {
      // Email
      if (field.type === 'email') return _this.settings.typeMismatchMessageEmail;

      // URL
      if (field.type === 'url') return _this.settings.typeMismatchMessageUrl;
    }

    // If too short
    if (validity.tooShort || validity.rangeUnderflow || validity.tooLong || validity.rangeOverflow) {
      return _this.settings.incorrectLengthMessage;
    }

    // If all else fails, return a generic catchall error
    return _this.settings.defaultMessage;
  };

  var el = config.el,
      settings = config.settings;

  // Set settings
  this.settings = _extends({}, defaultSettings, settings);

  // Configure state
  this.state = {
    hasErrors: false
  };

  // Set module dom elements
  this.form = el;
  this.fields = this.form.querySelectorAll(this.settings.fieldList);
};

export default function(settings) {
  return initialiser(settings, Validator);
} 